import React, { FC, ReactNode, memo } from 'react';
import classNames from 'classnames';
import { WarningPing } from '../WarningPing';

interface MessagePanelProps {
  type?: 'info' | 'error';
  className?: string;
  title?: React.ReactNode;
  description?: string;
  actions?: ReactNode;
  showWarningAnimation?: boolean;
}

export const MessagePanel: FC<MessagePanelProps> = memo((props) => {
  const { type = 'info', className, title, description, actions, showWarningAnimation = false } = props;

  const commonClasses = 'flex flex-col gap-2 px-4 py-5 bg-white rounded shadow-md';

  return (
    <div className={classNames(commonClasses, className)}>
      <div className="flex items-start">
        {showWarningAnimation && <WarningPing type={type} />}
        <div className="flex flex-col gap-2">
          <div className="font-semibold text-xl font-tektur">{title}</div>
          <div className="text-primaryLight">{description}</div>
        </div>
      </div>

      {actions}
    </div>
  );
});
